import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M27 26.05H3.547A.546.546 0 0 1 3 25.503V3.95h1.09v21.01H27"
    }, null, -1 /* CACHED */),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": ".5",
      d: "M27 26.05H3.547A.546.546 0 0 1 3 25.503V3.95h1.09v21.01H27"
    }, null, -1 /* CACHED */),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M21.281 21.534h1.76c.14 0 .253-.112.253-.253V8.72a.25.25 0 0 0-.253-.253h-1.76a.25.25 0 0 0-.25.253V21.28c0 .14.113.253.25.253m-4.772 0h1.76c.137 0 .25-.112.25-.253v-7.6a.253.253 0 0 0-.25-.253h-1.76a.254.254 0 0 0-.253.253v7.6c0 .14.113.253.253.253m-4.775 0h1.757c.14 0 .253-.112.253-.253v-10.05a.25.25 0 0 0-.253-.253h-1.757a.25.25 0 0 0-.253.253v10.05c0 .14.113.253.253.253m-4.775 0h1.76c.137 0 .25-.112.25-.253V16.76a.25.25 0 0 0-.25-.25h-1.76a.253.253 0 0 0-.253.25v4.522c0 .14.116.253.253.253"
    }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }